import { Container } from "@mui/material";
import React from "react";
import EnachRadios from "../components/Forms/EnachRadios";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";

export default function Enach() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={12} />
        <IntroCard
          title="ENACH"
          subtitle="Kindly select one of the below mentioned ENACH options."
          img="/assets/enach.svg"
        />
        <EnachRadios />
      </Container>
    </>
  );
}
